import React from "react";
import { Link, Redirect } from "react-router-dom";
import { AuthFrame } from "./auth-brand";
import "./login.css";

class LoginView extends React.Component {
  state = {
    detail: {},
    tokenSent: false,
  };

  handleChange = (value, prop) => {
    var t = this.state.detail;
    t[prop] = value;
    this.setState({ detail: t });
  };

  submit = () => {
    const { username, password } = this.state.detail;

    if (this.state.detail.isReset) {
      this.props.dispatchAuthenticate(username, password, null, null, true);
      this.setState({ tokenSent: true });
    } else {
      this.props.dispatchAuthenticate(username, password);
    }
  };

  reset = () => {
    const { username, password, confirmPassword, token } = this.state.detail;
    this.props.dispatchAuthenticate(username, password, token, confirmPassword, true);
  };

  forgotToken = () => {
    this.setState({ detail: { ...this.state.detail, isReset: true } });
  };

  backToSignIn = () => {
    this.setState({ detail: { ...this.state.detail, isReset: false }, tokenSent: false });
  };

  render() {
    if (this.props.user && this.props.user._id) {
      return <Redirect to="/" />;
    }

    const { detail, tokenSent } = this.state;
    const error = this.props.peopleState.signInErrorMessage;
    const isReset = detail.isReset;

    let card;

    if (isReset && tokenSent) {
      // Step 2 — enter the reset token + new password
      card = (
        <div className="auth-card" key="reset-token">
          <div className="auth-card-head">
            <h1>Reset password</h1>
            <p className="auth-sub">Check your email for the reset token, then set a new password.</p>
          </div>
          {error && <div className="auth-alert"><i className="fas fa-exclamation-circle" /> {error}</div>}
          <form onSubmit={(e) => { e.preventDefault(); this.reset(); }}>
            <label className="auth-field">
              <i className="fas fa-user" />
              <input type="text" placeholder="Username" autoComplete="username"
                value={detail.username || ""}
                onChange={(e) => this.handleChange(e.target.value, "username")} />
            </label>
            <label className="auth-field">
              <i className="fas fa-key" />
              <input type="text" placeholder="Reset token"
                value={detail.token || ""}
                onChange={(e) => this.handleChange(e.target.value, "token")} />
            </label>
            <label className="auth-field">
              <i className="fas fa-lock" />
              <input type="password" placeholder="New password" autoComplete="new-password"
                value={detail.password || ""}
                onChange={(e) => this.handleChange(e.target.value, "password")} />
            </label>
            <label className="auth-field">
              <i className="fas fa-lock" />
              <input type="password" placeholder="Confirm new password" autoComplete="new-password"
                value={detail.confirmPassword || ""}
                onChange={(e) => this.handleChange(e.target.value, "confirmPassword")} />
            </label>
            <button type="submit" className="auth-btn">Reset password</button>
          </form>
          <p className="auth-alt">
            <button type="button" className="auth-textlink" onClick={this.backToSignIn}>
              <i className="fas fa-arrow-left" /> Back to sign in
            </button>
          </p>
        </div>
      );
    } else if (isReset) {
      // Step 1 — request a reset token
      card = (
        <div className="auth-card" key="reset-request">
          <div className="auth-card-head">
            <h1>Forgot password?</h1>
            <p className="auth-sub">Enter your username and we'll email you a reset token.</p>
          </div>
          {error && <div className="auth-alert"><i className="fas fa-exclamation-circle" /> {error}</div>}
          <form onSubmit={(e) => { e.preventDefault(); this.submit(); }}>
            <label className="auth-field">
              <i className="fas fa-user" />
              <input type="text" placeholder="Username" autoComplete="username"
                value={detail.username || ""}
                onChange={(e) => this.handleChange(e.target.value, "username")} />
            </label>
            <button type="submit" className="auth-btn">Send reset token</button>
          </form>
          <p className="auth-alt">
            <button type="button" className="auth-textlink" onClick={this.backToSignIn}>
              <i className="fas fa-arrow-left" /> Back to sign in
            </button>
          </p>
        </div>
      );
    } else {
      // Sign in
      card = (
        <div className="auth-card" key="sign-in">
          <div className="auth-card-head">
            <h1>Sign in</h1>
            <p className="auth-sub">Welcome back — let's get you to work.</p>
          </div>
          {error && <div className="auth-alert"><i className="fas fa-exclamation-circle" /> {error}</div>}
          <form onSubmit={(e) => { e.preventDefault(); this.submit(); }}>
            <label className="auth-field">
              <i className="fas fa-user" />
              <input type="text" placeholder="Username" autoComplete="username" data-testid="login-username"
                value={detail.username || ""}
                onChange={(e) => this.handleChange(e.target.value, "username")} />
            </label>
            <label className="auth-field">
              <i className="fas fa-lock" />
              <input type="password" placeholder="Password" autoComplete="current-password" data-testid="login-password"
                value={detail.password || ""}
                onChange={(e) => this.handleChange(e.target.value, "password")} />
            </label>
            <button type="button" className="auth-link-right" onClick={this.forgotToken}>
              Forgot password?
            </button>
            <button type="submit" className="auth-btn" data-testid="login-submit">Sign in</button>
          </form>
          <p className="auth-alt">
            Don't have an account? <Link to="/register">Sign up</Link>
          </p>
        </div>
      );
    }

    return (
      <AuthFrame tagline="Welcome back to the app that runs the admin side of your trade.">
        {card}
      </AuthFrame>
    );
  }
}

export default LoginView;
